/**
 * Constantes unificadas para vetorizacao (livros e conteudos).
 * Single source of truth — todos os componentes importam daqui.
 */

// ---------------------------------------------------------------------------
// STATUS_CONFIG — Chip labels + cores para listagens e dashboards
// ---------------------------------------------------------------------------
export const STATUS_CONFIG = {
  // Livros — status amigaveis (listagem)
  vetorizado: { label: 'Vetorizado', color: 'default' },
  'em processamento': { label: 'Processando', color: 'primary' },
  pendente: { label: 'Pendente', color: 'default' },
  erro: { label: 'Erro', color: 'secondary' },

  // Conteudos — alias em ingles
  processing: { label: 'Processando', color: 'primary' },
  completed: { label: 'Concluido', color: 'default' },
  failed: { label: 'Falhou', color: 'secondary' },

  // Pipeline — status brutos (todas as etapas)
  UPLOAD_INICIADO: { label: 'Upload iniciado', color: 'primary' },
  ARQUIVO_ARMAZENADO: { label: 'Arquivo armazenado', color: 'primary' },
  PROCESSAMENTO_INICIADO: { label: 'Processamento iniciado', color: 'primary' },
  INDICE_GERADO: { label: 'Indice gerado', color: 'primary' },
  CONVERSAO_CONCLUIDA: { label: 'Conversao concluida', color: 'primary' },
  GERACAO_INICIADA: { label: 'Gerando unidades', color: 'primary' },
  GERACAO_CONCLUIDA: { label: 'Geracao concluida', color: 'primary' },
  VETORIZACAO_INICIADA: { label: 'Vetorizando', color: 'primary' },
  VETORIZACAO_CONCLUIDA: { label: 'Vetorizacao concluida', color: 'primary' },
  INICIADO: { label: 'Processando', color: 'primary' },
  PROCESSANDO: { label: 'Processando', color: 'primary' },
  FINALIZADO: { label: 'Finalizado', color: 'default' },
  ERRO: { label: 'Erro', color: 'secondary' },
  ERRO_UPLOAD: { label: 'Erro no upload', color: 'secondary' },
  ERRO_PROCESSAMENTO: { label: 'Erro no processamento', color: 'secondary' },
  ERRO_GERACAO: { label: 'Erro na geracao', color: 'secondary' },
  ERRO_VETORIZACAO: { label: 'Erro na vetorizacao', color: 'secondary' },
}

// ---------------------------------------------------------------------------
// STATUS_LABELS — Labels descritivos para timelines e modais de detalhe
// ---------------------------------------------------------------------------
export const STATUS_LABELS = {
  UPLOAD_INICIADO: 'Upload iniciado',
  ARQUIVO_ARMAZENADO: 'Arquivo armazenado',
  PROCESSAMENTO_INICIADO: 'Processamento iniciado',
  INDICE_GERADO: 'Indice gerado',
  CONVERSAO_CONCLUIDA: 'Conversao concluida',
  GERACAO_INICIADA: 'Geracao iniciada',
  GERACAO_CONCLUIDA: 'Geracao concluida',
  VETORIZACAO_INICIADA: 'Vetorizacao iniciada',
  VETORIZACAO_CONCLUIDA: 'Vetorizacao concluida',
  FINALIZADO: 'Finalizado',
  ERRO: 'Erro',
  ERRO_UPLOAD: 'Erro no upload',
  ERRO_PROCESSAMENTO: 'Erro no processamento',
  ERRO_GERACAO: 'Erro na geracao',
  ERRO_VETORIZACAO: 'Erro na vetorizacao',
  INICIADO: 'Processando',
  PROCESSANDO: 'Processando',
}

// ---------------------------------------------------------------------------
// Helpers de classificacao de status
// ---------------------------------------------------------------------------
const PROCESSING_STATUSES = new Set([
  'em processamento',
  'processing',
  'pendente',
  'UPLOAD_INICIADO',
  'ARQUIVO_ARMAZENADO',
  'PROCESSAMENTO_INICIADO',
  'INDICE_GERADO',
  'CONVERSAO_CONCLUIDA',
  'GERACAO_INICIADA',
  'GERACAO_CONCLUIDA',
  'VETORIZACAO_INICIADA',
  'VETORIZACAO_CONCLUIDA',
  'INICIADO',
  'PROCESSANDO',
])

const COMPLETED_STATUSES = new Set(['vetorizado', 'completed', 'FINALIZADO'])

const FAILED_STATUSES = new Set([
  'erro',
  'failed',
  'ERRO',
  'ERRO_UPLOAD',
  'ERRO_PROCESSAMENTO',
  'ERRO_GERACAO',
  'ERRO_VETORIZACAO',
])

export const isProcessing = (status) => PROCESSING_STATUSES.has(status)
export const isCompleted = (status) => COMPLETED_STATUSES.has(status)
export const isFailed = (status) => FAILED_STATUSES.has(status)

// ---------------------------------------------------------------------------
// Filtros padrao para listagens
// ---------------------------------------------------------------------------
export const STATUS_FILTERS = [
  { key: 'all', label: 'Todos' },
  { key: 'processing', label: 'Em Processamento' },
  { key: 'completed', label: 'Concluidos' },
  { key: 'failed', label: 'Com Erro' },
]



// WEBPACK FOOTER //
// ./src/constants/vectorization.js